import { CommonModule } from '@angular/common';
import { Component, computed, EventEmitter, Input, Output, signal, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ImageModule } from 'primeng/image';
import {
  PopulatedInstantFeedbackUserResponse
} from '../../../../../../libs/instant-feedback/config/src';
import { FeedbacksService } from '../../services/feedback.service';
import { AnalyticsEventsService } from '../../services/analytics-events.service';

@Component({
  selector: 'app-instant-feedback-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule, ImageModule],
  templateUrl: './instant-feedback-dialog.component.html',
  styleUrls: ['./instant-feedback-dialog.component.scss'],
})
export class InstantFeedbackDialogComponent implements OnInit {
  @Input() detail: PopulatedInstantFeedbackUserResponse | undefined;
  showCounterError: boolean = false;
  @Output() submitFeedback = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  constructor(
    private feedbackService: FeedbacksService,
    private readonly analyticsEventsService: AnalyticsEventsService,
  ) { }

  ratings = [1, 2, 3, 4, 5];
  selectedRating = signal<number | undefined>(undefined);

  selectRating(n: number) {
    this.selectedRating.set(n);
  }

  isSelectedRatingPopulated = computed((): boolean => {
    return this.selectedRating() !== undefined;
  });

  ngOnInit(): void {
    // Track feedback instant view when dialog opens
    if (this.detail?.id) {
      this.analyticsEventsService.trackFeedbackInstantView(this.detail.id);
    }
  }

  updateRating() {
    this.feedbackService.updateInstantFeedbackRatings(this.detail!.id, this.selectedRating()).subscribe(
      (response) => {
        if (this.selectedRating()) {
          // Track feedback instant complete
          this.analyticsEventsService.trackFeedbackInstantComplete(this.detail!.id);
          this.submitFeedback.emit();
          this.selectedRating.set(undefined);
          this.close.emit();
        } else {
          this.close.emit();
        }
      },
      (error: any) => {
        console.error('Error fetching open feedbacks:', error);
        if (error.status === 428) {
          this.showCounterError = true;
        } else {
          this.close.emit();
        }
      },
    );
  }

  submit() {
    this.updateRating();
  }

  closeDialog() {
    this.selectedRating.set(undefined);
    this.updateRating();
  }
}
